import React from 'react';
import styled from 'styled-components';
import { FaLaptop, FaMobileAlt, FaQrcode } from 'react-icons/fa';

const FeaturesSection = styled.section`
  width: 90%;
  max-width: 1200px;
  padding: 6rem 0;
  margin: 0 auto;

  @media screen and (max-width: 768px) {
    width: 100%;
    padding: 4rem 1.5rem;
  }
`;

const FeaturesHeader = styled.div`
  max-width: 640px;
  margin-bottom: 3.5rem;
`;

const Eyebrow = styled.p`
  font-family: var(--font-body);
  font-size: 0.85rem;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--color-accent-hover);
  margin-bottom: 1rem;
`;

const FeaturesTitle = styled.h2`
  font-family: var(--font-display);
  font-size: clamp(1.9rem, 3vw, 2.6rem);
  font-weight: 700;
  color: var(--color-brand-deep);
  margin-bottom: 1rem;
  line-height: 1.15;
`;

const FeaturesSubtitle = styled.p`
  font-family: var(--font-body);
  font-size: 1.05rem;
  color: var(--color-ink-soft);
  line-height: 1.6;
`;

const FeaturesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1.75rem;

  @media screen and (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const FeatureCard = styled.div`
  background: var(--color-white);
  border-radius: var(--radius-md);
  padding: 2.25rem 1.75rem;
  border: 1px solid var(--color-border);
  transition: transform 0.3s ease, box-shadow 0.3s ease, border-color 0.3s ease;

  &:hover {
    transform: translateY(-6px);
    border-color: var(--color-accent);
    box-shadow: var(--shadow-soft);
  }

  @media screen and (max-width: 768px) {
    &:nth-child(2) {
      transform: none;
    }
  }
`;

const FeatureIcon = styled.div`
  width: 52px;
  height: 52px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  color: var(--color-white);
  background: var(--color-brand);
  border-radius: var(--radius-sm);
  margin-bottom: 1.5rem;
`;

const FeatureTitle = styled.h3`
  font-family: var(--font-display);
  font-size: 1.35rem;
  font-weight: 600;
  margin-bottom: 0.75rem;
  color: var(--color-ink);
`;

const FeatureDescription = styled.p`
  font-family: var(--font-body);
  font-size: 1rem;
  color: var(--color-ink-soft);
  line-height: 1.6;
`;

const Features = () => {
  return (
    <FeaturesSection id="features">
      <FeaturesHeader>
        <Eyebrow>Recursos principais</Eyebrow>
        <FeaturesTitle>Sistema completo para gestão de restaurantes e bares</FeaturesTitle>
        <FeaturesSubtitle>
          Ferramentas que unem cardápio digital, atendimento e mobilidade para transformar a gestão do seu negócio.
        </FeaturesSubtitle>
      </FeaturesHeader>

      <FeaturesGrid>
        <FeatureCard>
          <FeatureIcon>
            <FaLaptop />
          </FeatureIcon>
          <FeatureTitle>Multi-plataforma</FeatureTitle>
          <FeatureDescription>
            Acesse o sistema de qualquer dispositivo, em qualquer lugar. Gerencie seu negócio com total mobilidade e praticidade.
          </FeatureDescription>
        </FeatureCard>

        <FeatureCard>
          <FeatureIcon>
            <FaMobileAlt />
          </FeatureIcon>
          <FeatureTitle>Cardápio digital</FeatureTitle>
          <FeatureDescription>
            Ofereça aos seus clientes uma experiência moderna com cardápio digital interativo, aumentando a satisfação e agilidade no atendimento.
          </FeatureDescription>
        </FeatureCard>

        <FeatureCard>
          <FeatureIcon>
            <FaQrcode />
          </FeatureIcon>
          <FeatureTitle>QR Code por mesa</FeatureTitle>
          <FeatureDescription>
            Facilite o acesso ao cardápio e agilize pedidos com QR Codes exclusivos para cada mesa, integrando a experiência física e digital.
          </FeatureDescription>
        </FeatureCard>
      </FeaturesGrid>
    </FeaturesSection>
  );
};

export default Features;
